import React from 'react'
import classNames from 'classnames'

interface IToolbarTabProps {
  name: string
  isActive: boolean
  onClick?: () => void
}

const ToolbarTab: React.FC<IToolbarTabProps> = ({name, isActive, onClick}) => {
  const css = classNames('ac-task-toolbar-tab', {
    'ac-task-toolbar-tab-b': !!onClick,
    active: isActive,
  })
  if (onClick) {
    return (
      <button className={css} onMouseDown={(e) => e.preventDefault()} onClick={onClick}>
        {name}
      </button>
    )
  } else {
    return <div className={css}>{name}</div>
  }
}

export {ToolbarTab}
